import { initFirebase } from '../firebase'
import { collection, getDocs, query, orderBy, startAfter, limit } from 'firebase/firestore'

const { db } = initFirebase()

// Safety/quality signals (ai-signals) and the archived intent-classifier logs
// (ai-intent, no longer written) are both flat, timestamp-ordered collections.
// They are read newest-first with a hard page limit + startAfter cursor — the
// previous unbounded getDocs() was the slow path.
//
// Only orderBy('timestamp') is used (single-field index, no composite needed);
// the last-N-days window and signal-type filters are applied client-side over the
// loaded pages.

export class FirebaseSignalService {
  // Returns one page newest-first from `collectionName`. Pass the previous page's
  // `cursor` (a QueryDocumentSnapshot) to continue.
  async getPage(collectionName, { pageSize = 50, cursor = null } = {}) {
    const col = collection(db, collectionName)
    const q = cursor
      ? query(col, orderBy('timestamp', 'desc'), startAfter(cursor), limit(pageSize))
      : query(col, orderBy('timestamp', 'desc'), limit(pageSize))
    const snap = await getDocs(q)
    return {
      items: snap.docs.map(d => ({ id: d.id, ...d.data() })),
      cursor: snap.docs.length ? snap.docs[snap.docs.length - 1] : null,
      hasMore: snap.size === pageSize
    }
  }
}
